import FacturaUpdate from './FacturaUpdate'
export {FacturaUpdate}
export default FacturaUpdate
